import { Injectable } from '@angular/core';
import { ApiService } from '../services/api.service';
import { UserStore } from '../state/user.store';

@Injectable({
  providedIn: 'root',
})
export class GroupsService {
  constructor(private apiService: ApiService, private userState: UserStore) {}

  get group() {
    return this.userState.group;
  }

  get leaderboard() {
    return this.userState.leaderboard;
  }

  getGroup() {
    const obs = this.apiService.getGroup();
    obs.subscribe((res) => {
      if (res) {
        this.userState.group.next(res);
      }
    });
    return obs;
  }

  createGroup(name: string) {
    const obs = this.apiService.createGroup(name);
    obs.subscribe(() => {
      this.getGroup();
    });
    return obs;
  }

  joinGroup(groupId: string) {
    const obs = this.apiService.joinGroup(groupId);
    obs.subscribe(() => {
      this.getGroup();
    });
    return obs;
  }

  getLeaderboard() {
    const obs = this.apiService.getLeaderboard();
    obs.subscribe((res) => {
      if (res) {
        this.userState.leaderboard.next(res);
      }
    });
    return obs;
  }

  createOrderGroup(coin: string, amount: string, operation: number) {
    const obs = this.apiService.createOrderGroup(coin, amount, operation);
    obs.subscribe(() => {
      this.getGroup();
    });
    return obs;
  }

  getPriceGroup(coin: string) {
    return this.apiService.getPriceGroup(coin);
  }

  getHistoryGroup(page, limit) {
    return this.apiService.getHistoryGroup(page, limit);
  }
}
